import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import CarriageContractDTO from '../../../../dto/CarriageContractDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import MultiTextInput from '../../../../components/fields/MultiTextInput/MultiTextInput';

export default function CarriageContractForm(props) {
  const { control, formMeta } = props;
  const dto = new CarriageContractDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_registry_number}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_inn}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          changeFormat="YYYY-MM-DD"
          onChangeToIso
          hideTime
          dtoObject={attributes.carriage_contract_effective_date}
          withLabel
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          changeFormat="YYYY-MM-DD"
          onChangeToIso
          hideTime
          withLabel
          dtoObject={attributes.carriage_contract_expiration_date}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carriage_contract_number}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={MultiTextInput}
          dtoObject={attributes.vehicle_registry_numbers}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1 mb-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="file"
          component={FileInput}
          dtoObject={attributes.carriage_file}
          variant="material"
        />
      </Row>
    </>
  );
}
